export const iconFontAwesomeScienceMagnet = (
	<i className="fa-solid fa-magnet"></i>
);
